import { Schema as c } from "./schema.js";
function p(e, o) {
  const t = {}, n = {};
  let r = -1;
  for (; ++r < e.length; )
    Object.assign(t, e[r].property), Object.assign(n, e[r].normal);
  return new c(t, n, o);
}
export {
  p as merge
};
//# sourceMappingURL=merge.js.map
